class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
  }

  connectedCallback() {
    if (this._abort && !this._abort.signal.aborted) return;
    this._abort = new AbortController();
    const signal = this._abort.signal;

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this), { signal });
      this.input.addEventListener('input', () => this.toggleResetButton(), { signal });
      this.input.addEventListener('input', () => {
        clearTimeout(this._changeTimer);
        this._changeTimer = setTimeout(() => {
          if (!signal.aborted && this.isConnected) this.onChange();
        }, 300);
      }, { signal });
    }
    this.toggleResetButton();
  }

  disconnectedCallback() {
    if (this._abort) this._abort.abort();
    clearTimeout(this._changeTimer);
  }

  toggleResetButton() {
    if (!this.resetButton || !this.input) return;
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden')
    } else if (this.input.value.length === 0  && !resetIsHidden) {
      this.resetButton.classList.add('hidden')
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a')
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.get('search-form') || customElements.define('search-form', SearchForm);
